var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertSelectIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4987 14.1667H16.6654L15.4946 12.9959C15.1771 12.6784 14.9987 12.2477 14.9987 11.7987V9.16667C14.9987 6.98964 13.6074 5.13757 11.6654 4.45118V4.16667C11.6654 3.24619 10.9192 2.5 9.9987 2.5C9.07822 2.5 8.33203 3.24619 8.33203 4.16667V4.45118C6.39004 5.13757 4.9987 6.98964 4.9987 9.16667V11.7987C4.9987 12.2477 4.82032 12.6784 4.50281 12.9959L3.33203 14.1667H7.4987M12.4987 14.1667V15C12.4987 16.3807 11.3794 17.5 9.9987 17.5C8.61799 17.5 7.4987 16.3807 7.4987 15V14.1667M12.4987 14.1667H7.4987",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertSelectIcon);
export default __webpack_public_path__ + "static/media/alert-select-icon.1705e226b67f9c8ef15daee637c1f0db.svg";
export { ForwardRef as ReactComponent };